/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSmsTemplateRequest
 */
export interface CreateSmsTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSmsTemplateRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSmsTemplateRequest
     */
    content: string;
}

/**
 * Check if a given object implements the CreateSmsTemplateRequest interface.
 */
export function instanceOfCreateSmsTemplateRequest(value: object): value is CreateSmsTemplateRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function CreateSmsTemplateRequestFromJSON(json: any): CreateSmsTemplateRequest {
    return CreateSmsTemplateRequestFromJSONTyped(json, false);
}

export function CreateSmsTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSmsTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'content': json['content'],
    };
}

export function CreateSmsTemplateRequestToJSON(json: any): CreateSmsTemplateRequest {
    return CreateSmsTemplateRequestToJSONTyped(json, false);
}

export function CreateSmsTemplateRequestToJSONTyped(value?: CreateSmsTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'content': value['content'],
    };
}

